// extracted by mini-css-extract-plugin
module.exports = {"primaryDashboard":"PrimaryDashboard_primaryDashboard__Sp2ef","primaryDashboardTopButtonsContainer":"PrimaryDashboard_primaryDashboardTopButtonsContainer__PkcNw"};